import { Dialog, DialogActions, DialogContent, Divider, TextField } from "@material-ui/core";
import React, { useState } from "react";
import { CardCvcElement, CardExpiryElement, CardNumberElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { useSelector } from "react-redux";
import Axios from "axios";

export default function CreatePaymentMethod({refresh}) {
    const stripe = useStripe();
    const elements = useElements();
    const [open, setOpen] = useState(false);
    const { user } = useSelector((state) => state.auth);
    const [paymentMethodId, setPaymentMethodId] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const {subscription_details} = useSelector(state => state.subscriptionData?.subscriptionData?.original);
    
    const handleModalState = () => {
        setOpen(!open);
    };
    
    const handleChange = async (event) => {
        if(event.complete){
            const {error, paymentMethod} = await stripe.createPaymentMethod({
                type: 'card',
                card: elements.getElement(CardNumberElement),
                billing_details:{
                    name: `${user.fullname}`
                }
            });
            if(!error && typeof paymentMethod === 'object'){
                setPaymentMethodId(paymentMethod.id);
            }
        }
    };
    
    const handleSubmit = async () => {
        setSubmitting(true);
        let data = {
            stripe_id: subscription_details.subscription_id,
            payment_method_id: paymentMethodId,
        };
        await Axios.post('/api/v2/subscriptions/add_payment_method', data)
        .then(() => {
            handleModalState();
            refresh();
        })
        .catch((err) => {
            console.log(err);
        })
        .finally(() => {
            setSubmitting(false);
        });
    };
    
    return(
        <div className="ml-auto">
            <button
                type="button"
                className="btn btn-light-primary font-weight-bold btn-sm"
                onClick={handleModalState}
            >
                Add Payment Method
            </button>
            <Dialog open={open} maxWidth="sm" fullWidth className="rounded">
                <DialogContent className="d-flex flex-column">
                    <h4 className="m-0">Add Payment Method</h4>
                    <p className="m-0 text-muted font-italic font-weight-normal">Add a new credit card for billing.</p>
                    <div className="mt-5 d-flex flex-column align-self-left col-12 px-0">
                        <label htmlFor="company" className="font-weight-bolder">Billed to</label>
                        <input type="text" className="form-control bg-white text-black" placeholder="Enter your Card Name" fullWidth/>
                    </div>
                    <div className="mt-2 d-flex flex-column align-self-left col-12 px-0">
                        <label htmlFor="company" className="font-weight-bolder">Card Number</label>
                        <div className="form-control h-auto" style={{padding: '24px'}}>
                            <CardNumberElement onChange={(e) => handleChange(e)}/>
                        </div>
                    </div>
                    <div className="mt-3 d-flex flex-row col-12 px-0">
                        <div className="col-6 pl-0">
                            <div className="d-flex flex-column">
                                <label htmlFor="company" className="font-weight-bolder">Expiry</label>
                                <div className="form-control h-auto" style={{padding: '24px'}}>
                                    <CardExpiryElement onChange={(e) => handleChange(e)}/>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 pr-0">
                            <div className="d-flex flex-column">
                                <label htmlFor="company" className="font-weight-bolder">CVC</label>
                                <div className="form-control h-auto" style={{padding: '24px'}}>
                                    <CardCvcElement onChange={(e) => handleChange(e)}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <DialogActions className="mt-2 px-0 d-flex flex-row gap-3 justify-content-start">
                        <button
                            type="button"
                            className="btn btn-light-primary font-weight-bold btn-sm"
                            onClick={handleSubmit}
                            disabled={submitting}
                        >
                            {submitting && <div className="spinner-border spinner-border-sm"></div>} Add Card
                        </button>
                        <button
                            type="button"
                            className="btn btn-light-danger font-weight-bold btn-sm"
                            onClick={handleModalState}
                            disabled={submitting}
                        >
                            Cancel
                        </button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
        </div>
    );
}